/* we-v24.js (v2.4 "Format and friction" DRAFT, Oct 27 2026). Deferred, loaded by layout/theme.liquid. Touches no price, no cart, no Moon data.
   1) chat bubble: body.we-v24-atc-view while any Add to cart button is on screen (hides the bubble on phones/tablets, see we-v24.css block 3);
   2) email pop-up strip: sets --we-pop-b (sits above the sticky bar), --we-pop-sa (safe area) and data-we-yield (hidden while an Add to cart is on screen). */
(function () {
  'use strict';
  var d = document, queued = false;
  function onScreen(el) {
    var r = el.getBoundingClientRect();
    if (r.width < 1 || r.height < 1 || r.bottom <= 0 || r.top >= window.innerHeight) return false;
    var cs = window.getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none';
  }
  function atcOnScreen() {
    var list = d.querySelectorAll('.we-wd__btn, .duo-main button, .we-moon button, .we-cta, [data-we-moon-box] button, moonbundle-component button');
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      if (b.closest('.duo-sticky, .duo-pop, [hidden], [inert]')) continue;
      if (!b.classList.contains('we-cta') && !/^\s*add\b/i.test(b.textContent || '')) continue;
      if (onScreen(b)) return true;
    }
    return false;
  }
  function run() {
    queued = false;
    var inView = atcOnScreen();
    d.body.classList.toggle('we-v24-atc-view', inView);
    var pop = d.querySelector('[data-duo-pop]');
    if (!pop || pop.hidden) return;
    var s = d.querySelector('.duo-sticky'), off = 0;
    if (s && window.getComputedStyle(s).display !== 'none') {
      var r = s.getBoundingClientRect();
      if (r.height > 0 && r.top < window.innerHeight) off = Math.max(0, Math.round(window.innerHeight - r.top));
    }
    pop.style.setProperty('--we-pop-b', off + 'px');
    pop.style.setProperty('--we-pop-sa', off ? '0px' : 'env(safe-area-inset-bottom, 0px)');
    if (inView) pop.setAttribute('data-we-yield', ''); else pop.removeAttribute('data-we-yield');
  }
  function queue() { if (queued) return; queued = true; (window.requestAnimationFrame || setTimeout)(run); }
  function start() {
    run();
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    var pop = d.querySelector('[data-duo-pop]');
    if (pop && 'MutationObserver' in window) new MutationObserver(queue).observe(pop, { attributes: true, attributeFilter: ['hidden'] });
    if ('MutationObserver' in window) new MutationObserver(queue).observe(d.body, { childList: true, subtree: true });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();
